import type { RobotRead } from 'api/schema'

import { FACILITY_NONE_ID, type TasksNormalizedFilterState } from './filterableRecord'

/**
 * Robot DB ids to pass as `robot_ids` to normalized APIs when filters narrow the fleet.
 * Returns `undefined` when no filter implies a subset (same as “all allowed robots” on the server).
 * Mission / “start after” filters are client-side only — they do not narrow this list.
 */
export function resolveRobotIdsFromFilters(
  filterState: TasksNormalizedFilterState,
  robots: RobotRead[],
  facilities: { id: number; robots_ids?: number[] }[]
): number[] | undefined {
  const sn = filterState.robotSn.trim()
  if (sn) {
    const r = robots.find(x => String(x.serial_number ?? '').trim() === sn)
    return r?.id != null ? [r.id] : []
  }

  const vendor = filterState.vendor.trim()
  const fidRaw = filterState.facilityId.trim()
  const hasFacility = Boolean(fidRaw && fidRaw !== FACILITY_NONE_ID)

  if (!vendor && !hasFacility) {
    return undefined
  }

  let pool = robots
  if (vendor) {
    pool = pool.filter(r => r.vendor === vendor)
  }
  if (hasFacility) {
    const n = Number(fidRaw)
    if (!Number.isFinite(n)) return []
    const fac = facilities.find(f => f.id === n)
    const allowed = new Set((fac?.robots_ids ?? []).filter((x): x is number => Number.isFinite(x)))
    pool = pool.filter(r => allowed.has(r.id))
  }

  return pool.map(r => r.id)
}
